import { config, TranslationCollection, TranslationField } from '@/test';
import { clearContext, endUsers, getContext, RestClient, users } from '@websolutespa/test/payload';
import { Payload, RichTextField, SanitizedCollectionConfig, TextField } from 'payload';
import { afterAll, beforeAll, describe, expect, it } from 'vitest';
import { options } from '../../options';
import { getTranslation } from './translations';

describe('Translations', () => {

  let payload: Payload;
  let client: RestClient;
  let userToken: string;
  let endUserToken: string;
  let apiKey: string;

  beforeAll(async () => {
    const context = await getContext(config);
    payload = context.payload;
    client = context.client;
    userToken = await client.getToken('users', users.admin);
    endUserToken = await client.getToken('end_users', endUsers.user);
    apiKey = users.api.apiKey;
  });

  afterAll(async () => {
    await clearContext();
  });

  describe('Collection config', () => {
    let collectionConfig: SanitizedCollectionConfig;

    beforeAll(async () => {
      collectionConfig = payload.config.collections.find(collection => collection.slug === TranslationCollection.slug)!;
    });

    describe('Custom translations (via i18n.resources)', () => {
      it('labels should be correctly translated', () => {
        options.locales.forEach(locale => {
          const code = typeof locale === 'string' ? locale : locale.code;
          const collection = options.translations[code].collection as {
            [key: string]: any;
          };
          const labels = collectionConfig.labels as {
            [key: string]: any;
          };
          expect(labels.singular[code]).toEqual(collection.singular[TranslationCollection.slug]);
          expect(labels.plural[code]).toEqual(collection.plural[TranslationCollection.slug]);
        });
      });

      it('fields should be correctly translated', () => {
        const field = collectionConfig.fields.find(field => field.type === 'text' && field.name === (TranslationField as TextField).name!) as TextField;
        const label = field.label as {
          [key: string]: any;
        };
        options.locales.forEach(locale => {
          const code = typeof locale === 'string' ? locale : locale.code;
          expect(label[code]).toEqual((options.translations as any)[code].field[(TranslationField as TextField).name!]);
        });
      });
    });

    describe('Default translations (defined in tranlsations.ts)', () => {
      it('fields should be correctly translated', () => {
        const field = collectionConfig.fields.find(field => field.type == 'richText' && field.name === 'description') as RichTextField;
        const label = field.label as {
          [key: string]: any;
        };
        options.locales.forEach(locale => {
          const code = typeof locale === 'string' ? locale : locale.code;
          expect(label[code]).toEqual((options.translations as any)[code].field[field.name]);
        });
      });
    });
  });

  describe('getTranslation()', () => {
    const locale = 'en';

    it('should return a translation for a valid path', () => {
      const translatedValue = getTranslation(`collection.singular.${TranslationCollection.slug}`, '', locale);
      const collection = options.translations[locale].collection as {
        [key: string]: any;
      };
      expect(translatedValue).toEqual(collection.singular[TranslationCollection.slug]);
    });

    it('should return a default value for an invalid path', () => {
      const translatedValue = getTranslation('collection.singular.undefinedCollection', '', locale);
      expect(translatedValue).toEqual('');
    });
  });
});
